const GET_SEARCH_PRODUCTS = 'GET_SEARCH_PRODUCTS';
const CLEAR_SEARCH_PRODUCTS = 'CLEAR_SEARCH_PRODUCTS';
export { GET_SEARCH_PRODUCTS, CLEAR_SEARCH_PRODUCTS }